import { Spinner } from 'react-bootstrap'
import HomeComponent from '../components/HomeComponent/HomeComponent'
import useFetch from '../hooks/useFetch'
import ErrorComponent from '../components/ErrorComponent/ErrorComponent'

function HomePage() {
  const { data, loading, error } = useFetch(
    'home',
    (resp) => resp?.data?.sectiondata || {}
  )

  if (loading) {
    return (
      <div className="flex justify-center mt-8">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {error?.hasError ? (
        <div className="flex justify-center">
          <ErrorComponent errorMessage={error.errorMessage} />
        </div>
      ) : (
        <HomeComponent data={data} />
      )}
    </>
  )
}

export default HomePage
